<tour-step-template>
  <ng-template let-step="step">
    <mat-card
      (click)="$event.stopPropagation()"
      [style.width]="step.stepDimensions?.width"
      [style.min-width]="step.stepDimensions?.minWidth"
      [style.max-width]="step.stepDimensions?.maxWidth"
      >
      <mat-card-header>
        <div class="header-group">
          <mat-card-title>
            {{ step.title }}
          </mat-card-title>
          <button (click)="tourService.end()" class="btn icon-close"></button>
        </div>
      </mat-card-header>

      <mat-card-content class="mat-body">
        @if (step.videoId) {
          <app-youtube-preview [thumbnail]="step.thumbnail" [videoId]="step.videoId"></app-youtube-preview>
        }

        <div [innerHTML]="step.content"></div>
      </mat-card-content>

      @if (tourService.hasPrev(step) || tourService.hasNext(step)) {
        <mat-card-actions
          [class.no-progress]="!step.showProgress">
          <button
            class="btn link icon primary"
            [class.invisible]="!tourService.hasPrev(step)"
            (click)="tourService.prev()"
            >
            <i class="icon icon-angle-left"></i>
            {{ step.prevBtnTitle }}
          </button>
          @if (step.showProgress) {
            <div class="progress">{{ tourService.steps.indexOf(step) + 1 }} / {{ tourService.steps.length }}</div>
          }
          @if (tourService.hasNext(step) && !step.nextOnAnchorClick) {
            <button class="btn compact icon primary" (click)="tourService.next()">
              {{ step.nextBtnTitle }}
              <i class="icon icon-angle-right"></i>
            </button>
          }
          @if (!tourService.hasNext(step)) {
            <button class="btn compact primary" (click)="tourService.end()">
              {{ step.endBtnTitle }}
            </button>
          }
        </mat-card-actions>
      }
    </mat-card>
  </ng-template>
</tour-step-template>
